var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { addCssClass } from '../../dom';
import { getNumberCellValue } from '../number-cell-renderer';
import animateCellChange from '../animate-cell-change/animate-cell-change.decorator';
import isEqual from 'lodash/isEqual';
const TEMPLATE = `
    <span class="ag-value-currency"></span>
    <span class="ag-value-change-delta"></span>
    <span class="ag-value-amount">
        <span class="ag-value-change-value"></span>
    </span>
`;
export class CurrencyAmountCellRendererBase {
    constructor() {
        this.eGui = document.createElement('span');
        addCssClass(this.eGui, 'ag-cell-value-wrapper ag-cell-value-wrapper--currency');
        this.eGui.innerHTML = TEMPLATE;
        this.lastValue = undefined;
    }
    init(params) {
        this.eValue = this.getGui().querySelector('.ag-value-change-value');
        this.eDelta = this.getGui().querySelector('.ag-value-change-delta');
        this.eCurrency = this.getGui().querySelector('.ag-value-currency');
        this.refresh(params);
    }
    getGui() {
        return this.eGui;
    }
    refresh(params) {
        const value = getNumberCellValue(params.value);
        if (isEqual(value, this.lastValue)) {
            return;
        }
        this.lastValue = value;
        this.updateDOM(params);
        // eslint-disable-next-line consistent-return
        return true;
    }
}
__decorate([
    animateCellChange({
        timer: 2000,
        highlight: true,
        delta: true,
    })
], CurrencyAmountCellRendererBase.prototype, "refresh", null);
